import { useEffect, useState } from "react";
import axios from "axios";
import _ from "lodash";
import moment from "moment";

import { config, changeConfig } from "../constants/config";
import { endpoints } from "./endpoints";
import { EResourcesState } from "../Types/ResourcesState";
import { convertTime, getPostFormat } from "./helpers";
import { EConfigEnum } from "../Types/ConfigEnum";
import { TO } from "./TO";

function ageGroupsFormatter(items) {
	const orderedItems = _.sortBy(items, [(o) => o.custom_fields?.order]);
	return _.map(orderedItems, (o) => ({
		title: o.name,
		ageGroup: o.description,
		bgColor: o.custom_fields.bubbleColor,
		circleColor: o.custom_fields.circleColor,
		order: o.custom_fields?.order,
		selected: false,
		id: o.id,
	}));
}
function categoriesFormatter(items, lang = "en") {
	const formatedItems = _.map(items, (item) => ({
		id: item.id,
		name: item.name,
		queryParam: item.id,
		active: false,
	}));

	formatedItems.unshift({
		id: null,
		name: lang.toLowerCase().includes("ar") ? "الكل" : "All",
		queryParam: null,
		active: true,
		isCategoryAll: true,
	});

	return formatedItems;
}

function tagsFormatter(items, lang = "en") {
	const formatedItems = _.map(items, (item) => ({
		id: item.id,
		name: item.name,
		queryParam: item.id,
		active: false,
	}));

	formatedItems.unshift({
		id: 93489231,
		name: lang.toLowerCase().includes("ar") ? "الكل" : "All",
		queryParam: null,
		active: true,
		isTagAll: true,
	});

	return formatedItems;
}

function prTypesFormatter(items) {
	return {
		video: {
			id:
				_.find(
					items,
					(prType) => prType.name === "video" || prType.name === "فيديو"
				)?.id || null,
			value: "video",
		},
		article: {
			id:
				_.find(
					items,
					(prType) => prType.name === "article" || prType.name === "مقالات"
				)?.id || null,
			value: "article",
		},
	};
}
//
function categoriesFilter(usedTermsArr, categories, lang = "en") {
	const usedItems = [];

	for (const usedTerm of usedTermsArr)
		for (const category of categories)
			if (category.id === usedTerm) usedItems.push(category);

	usedItems.unshift({
		id: null,
		name: lang.toLowerCase().includes("ar") ? "الكل" : "All",
		queryParam: null,
		active: true,
		isCategoryAll: true,
	});

	return usedItems;
}

function tagsFilter(usedTermsArr, tags, lang = "en") {
	const items = [];

	for (const usedTerm of usedTermsArr)
		for (const tag of tags) if (tag.id === usedTerm) items.push(tag);

	items.unshift({
		id: 93489231,
		name: lang.toLowerCase().includes("ar") ? "الكل" : "All",
		queryParam: null,
		active: true,
		isTagAll: true,
	});

	return items;
}
//

export function postsFormatter(data, categories, prTypes) {
	return _.map(data, (o) => ({
		id: o.id,
		link: o.link || o.url,
		title: o.title?.rendered || o.title,
		date: moment(o.date).format("MM.DD.YYYY"),
		category: o["pr-category" ] ?
			_.find(categories, (cat) => cat.id === o["pr-category"][0])?.name :
			"Default category",
		imageMarkup: o.images.markup,
		postType: getPostFormat(prTypes, Array.isArray(o["pr-type"]) && o["pr-type"]?.length ? o["pr-type"][0] : o["type"] ),
	}));
}

function initPostsFormatter(data) {
	const formmated = _.map(data, (o) => ({
		id: o.ID,
		link: o.link || "",
		title: o.post_title || "",
		date: moment(o.post_date).format("MM.DD.YYYY") || "",
		category: o?.pr_category?.name || "Default category",
		imageMarkup: o.thumbnail || "",
		postType: o.pr_type || "",
	}));


	return formmated;
}

export const useApiRes = (ageGroupId = null) => {
	const [state, setState] = useState(EResourcesState.Created);

	const [initData, setInitData] = useState({
		ageGroups: null,
		categories: null,
		tags: null,
		prTypes: null,
		usedCategories: {},
	});

	const [useableData, setUsebleData] = useState(null);

	const [queryParams, setQueryParams] = useState({
		ageGroup: ageGroupId,
		category: null,
		tags: [],
		prType: null,
		page: 1,
		lang: "EN",
		search: null,
	});
	const [ROOT_API, setRootApi] = useState("");

	const [discoverMore, setDiscoverMore] = useState(true);
	const [disabledButton, setDisabledButton] = useState(false);

	const [posts, setPosts] = useState(null);

	useEffect(() => {
		/**
		 * Fetch age groups, categories, tags and usedTerms for every age group
		 * First load of post is extracted from an existed global variabile
		 */
		async function fetchInitData() {
			let initParameters = {
				url: "https://ecawebstage.uaenorth.cloudapp.azure.com",
				lang: "en",
				posts: [],
			};
			//  initParameters = window["parent_resources_onload"];
			//* only for dev
			if ("parent_resources_onload" in window) {
				initParameters = window["parent_resources_onload"];

			}
			const { url: API_DOMAIN, lang, posts } = initParameters;
			setRootApi(API_DOMAIN + (API_DOMAIN.endsWith("/") ? "" : "/") + "wp-json/wp/");
			changeConfig(
				EConfigEnum.API_DOMAIN,
				`${API_DOMAIN + (API_DOMAIN.endsWith("/") ? "" : "/")}wp-json/wp`
			);
			changeConfig(
				EConfigEnum.CUSTOM_API_DOMAIN,
				`${API_DOMAIN + (API_DOMAIN.endsWith("/") ? "" : "/")}wp-json/eca`
			);

			setQueryParams((s) => ({ ...s, lang }));

			const FULL_API =
				API_DOMAIN + (API_DOMAIN.endsWith("/") ? "" : "/") + "wp-json/wp";

			const URLs = [
				FULL_API + endpoints.ageGroups,
				FULL_API + endpoints.categories,
				FULL_API + endpoints.tags,
				FULL_API + endpoints.prTypes,
			];


			let responses = null;

			let ageGroupsId = [];

			try {
				//*
				setState(EResourcesState.Pending);


				responses = await Promise.all(_.map(URLs, (url) => axios.get(url)));

			} catch (error) {
				console.error(
					"Error while fetching init data for explore-resources (useApiRes  line 25): ",
					error
				);

				setState(EResourcesState.Error);

				return;
				//*
			}

			/**
			 * Formatting data
			 */
			let formattedData = {};

			try {
				//*
				const ageGroups = ageGroupsFormatter(responses[0].data);

				_.forEach(ageGroups, ({ id }) => ageGroupsId.push(id));

				formattedData = {
					ageGroups,
					categories: categoriesFormatter(responses[1].data, lang),
					tags: tagsFormatter(responses[2].data, lang),
					prTypes: prTypesFormatter(responses[3].data, lang),
				};



				//*
			} catch (error) {
				//*
				console.error(
					"Error while formatting data (useApiRes line 118): ",
					error
				);

				setState(EResourcesState.Error);

				return;
				//*
			}
			/**
			 * Get used terms for every ageGroup
			 */
			let usedTermsResponses = null;

			try {
				usedTermsResponses = await Promise.all(
					_.map(ageGroupsId, (ageGroup) => {

						return axios.get(
							API_DOMAIN +
								(API_DOMAIN.endsWith("/") ? "" : "/") +'wp-json/eca/' +
								endpoints.usedTerms({ ageGroup })
						);
					})
				);
			} catch (e) {
				console.error("Error: ", e);

				setState(EResourcesState.Error);

				return;
			}

			const usedTermsPerCategory = {};

			for (let idx = 0; idx < ageGroupsId.length; idx++) {
				const terms = JSON.parse(usedTermsResponses[idx].data).map((i) =>
					parseInt(i)
				);

				usedTermsPerCategory[ageGroupsId[idx]] = terms;
			}

			formattedData.usedCategories = usedTermsPerCategory;

			setInitData(formattedData);

			setUsebleData(formattedData);

			//*

			if (!ageGroupId) {
				setPosts(initPostsFormatter(posts));

				setState(EResourcesState.Ready);

				return;
			}

			setState(EResourcesState.Pending);

			const [err, result] = await TO(
				axios.get(endpoints.getPosts({ ageGroup: ageGroupId }))
			);

			if (err) {
				setState(EResourcesState.Error);
				return;
			}

			setPosts(postsFormatter(result.data));
			const totalpages = Number(result.headers['x-wp-totalpages']);
			const pageCount = 1;
			if(pageCount>=totalpages){
				setDiscoverMore(false);
			}
			else{
				setDiscoverMore(true);
			}
			setState(EResourcesState.Ready);
		}

		setTimeout(() => {
			fetchInitData();
		}, 500);

		// getInitPostsAndSetting();
	}, []);

	/**
	 * Private functionality
	 *
	 */
	async function _fetchPosts(param) {
		const instance = axios.create({
			baseURL: config.API_DOMAIN,
		});
		const currentQuerryParams = { ...queryParams, ...param };

		const endpoint = endpoints.getPosts({
			lang: currentQuerryParams.lang,
			page: 1,
			ageGroup: currentQuerryParams.ageGroup,
			category: currentQuerryParams.category,
			contentType: currentQuerryParams.prType,
			tags: currentQuerryParams.tags,
		});


		//Reset page for every request

		setQueryParams((s) => ({ ...s, page: 1 }));

		let response = null;

		try {
			//*
			response = await instance.get(endpoint);
			//*
		} catch (error) {
			//*
			console.error("Error: ", error);

			setState(EResourcesState.Error);

			return;
			//*
		}
		setPosts(
			postsFormatter(response.data, initData.categories, initData.prTypes)
		);

		const totalpages = Number(response.headers['x-wp-totalpages']);
		const pageCount = queryParams.page ? queryParams.page : 1;
		if(pageCount>=totalpages){
			setDiscoverMore(false);
		}
		else{
			setDiscoverMore(true);
		}

		setState(EResourcesState.Ready);
	}

	async function _filteringSelectable(param) {
		const instance = axios.create({
			baseURL: config.API_DOMAIN,
		});
		const { ageGroup, category } = { ...queryParams, ...param };
		//
		if (!ageGroup && !category) return setUsebleData(initData);

		let response = null;

		try {
			//*
			// 	"usedTerms endpoint: ",
			// 	endpoints.usedTerms({ ageGroup, category })
			// );
			response = await instance.get(
				ROOT_API.slice(0, ROOT_API.length-3)+'eca/' + endpoints.usedTerms({ ageGroup, category })
			);
			//*
		} catch (error) {
			//*
			console.error("Error: ", error);

			setState(EResourcesState.Error);

			return;
			//*
		}

		const usedTerms = JSON.parse(response.data).map((i) => parseInt(i));

		setUsebleData((s) => ({
			...s,
			categories: ageGroup
				? categoriesFilter(
						initData.usedCategories[ageGroup],
						initData.categories,
						queryParams.lang
				  )
				: initData.categories,
			tags: tagsFilter(usedTerms, initData.tags, queryParams.lang),
		}));
	}
	/**
	 * Set queries and make request for posts
	 */
	function selectQueryParams(param) {
		setQueryParams((s) => ({ ...s, ...param }));

		/**
		 * Filter categories and tags
		 *
		 */

		_filteringSelectable(param);

		/**
		 * Fetch posts
		 */

		_fetchPosts(param);
	}
	/**
	 * Fetch next page, the size of page is set up from config file
	 *
	 */
	async function fetchNextPage() {
		setDisabledButton(true);
		const instance = axios.create({
			baseURL: config.API_DOMAIN,
		});
		const pageCount = queryParams.page === 1 ? 2 : queryParams.page + 1;

		const endpoint = endpoints.getPosts({
			lang: queryParams.lang,
			page: pageCount,
			ageGroup: queryParams.ageGroup,
			category: queryParams.category,
			contentType: queryParams.prType,
			tags: queryParams.tags,
		});

		setQueryParams((s) => ({ ...s, page: pageCount }));

		let response = null;

		try {
			//*
			response = await instance.get(endpoint);
			//*
		} catch (error) {
			//*
			console.error("Error: ", error);

			setState(EResourcesState.Error);

			return;
			//*
		}

		setPosts(
			[...posts, ...postsFormatter(response.data, initData.categories, initData.prTypes)]
		);

		const totalpages = Number(response.headers['x-wp-totalpages']);
		if(pageCount>=totalpages){
			setDiscoverMore(false);
		}
		else{
			setDiscoverMore(true);
		}
		setDisabledButton(false);
		// if (response.data.length) setDiscoverMore(true);
		// else setDiscoverMore(false);

		setState(EResourcesState.Ready);
	}

	return {
		lang: queryParams.lang,
		state,
		data: useableData,
		posts,
		discoverMore,
		selectQueryParams,
		fetchNextPage,
		disabledButton,
	};
};
